var map = {
	"./prism-atom-dark.css": 70,
	"./prism-base16-ateliersulphurpool.light.css": 71,
	"./prism-cb.css": 72,
	"./prism-duotone-dark.css": 73,
	"./prism-duotone-earth.css": 74,
	"./prism-duotone-forest.css": 75,
	"./prism-duotone-light.css": 76,
	"./prism-duotone-sea.css": 77,
	"./prism-duotone-space.css": 78,
	"./prism-ghcolors.css": 79,
	"./prism-hopscotch.css": 80,
	"./prism-pojoaque.css": 81,
	"./prism-vs.css": 82,
	"./prism-xonokai.css": 83
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;